import { ClaudeTemplate } from "../types";

/** ChatGPT Ads: plataforma nueva, pasos genéricos a propósito. */
export const chatgptAdsTemplate: ClaudeTemplate = {
  id: "chatgpt-ads",
  tool: "ChatGPT Ads (OpenAI)",
  url: "la plataforma de anuncios de OpenAI / ChatGPT (la URL de acceso no está confirmada: si no la sabes, pregúntamela)",
  hierarchy:
    "Cuenta → Campaign → grupo de anuncios / ad set → Ads (es una plataforma nueva: la jerarquía puede variar)",
  idHint: "ID de la campaña donde lo muestre la herramienta (URL o detalle)",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre la plataforma de anuncios de ChatGPT. Si no sabes la URL o no tienes acceso, para y pregúntame.
2. Elige la cuenta de {{client}}. Si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques.
2. Si no existe, créala con nombre {{names.order}}, fechas {{goal.startDate}} → {{goal.endDate}} y presupuesto {{goal.budget}}. Objetivo: el que encaje con {{goal.kpi}}.

### 3. Grupo / ad set
1. Nombre: {{names.line}}.
2. Segmentación: país {{goal.country}}, geografía {{target.geography}}, idioma {{target.language}}, temas o contextos de conversación {{target.interests}}, audiencias {{target.audience}}, exclusiones {{target.exclusions}}.
3. Puja / coste objetivo: en torno a {{goal.netUnitCost}} si la herramienta lo permite.

### 4. Ads
1. Tipo según {{campaignType}}: CHAT_ADS → anuncio en conversación (texto + enlace); PRODUCT_ADS → producto / catálogo (si no hay catálogo conectado, pregunta).
2. Textos: bloque "Copies". Imágenes: bloque "Creatividades". URL de destino con UTM: bloque "URLs de destino".
3. Deja todo **en pausa o en borrador**.
`,
};
